import * as React from 'react';

import { PromoBanner } from '../../components/PromoBanner/PromoBanner';
import { SectionBlock } from '../../components/SectionBlock';
import { useSelector } from 'react-redux';
import { getTemplateSpecialPromoBannerStretch } from '../../selectors/developerV2/templateSpecialPromo/getTemplateSpecialPromoBannerStretch';

export const PromoBannerContainer: React.FC = () => {
  const bannerStretch = useSelector(getTemplateSpecialPromoBannerStretch);

  if (!bannerStretch) {
    return null;
  }

  return (
    <SectionBlock id="promo-banner">
      <PromoBanner
        image={bannerStretch.image.url}
        hitUrl={bannerStretch.link}
        disclaimer={bannerStretch.disclaimer}
        withAdLabel={bannerStretch.isAdvertisingOn}
      />
    </SectionBlock>
  );
};
